// extracted by mini-css-extract-plugin
export default {"mail":"Mail_mail__5oOby","mailInputContainer":"Mail_mailInputContainer__kdymO"};